import output from "_src/engine/output";

let _cache = null;
export default {
  async init() {
    const cacheAvailable = "caches" in global;
    if (!cacheAvailable) {
      output.warn( "Can't initialize cache: api is not supported by the platform");
      return;
    }

    try {
      const cache = await caches.open("artec-web-studio");
      _cache = cache;
    } catch (error) {
      output.warn( "Can't initialize cache. " + error);
    }
  },

  put(id, data) {
    if (!_cache) return;

    const response = new Response(data, {"status" : 200});
    _cache.put(id, response);
  },

  async extract(id) {
    if (!_cache) return;
    const fileReader = new FileReader();

    const response = await _cache.match(id);
    if (!response) {
      output.error(output.STORAGE_ERROR, "Can't extract object from cache. No response with id:" + id);
      return;
    }
    const blob = await response.blob();
    return new Promise((resolve) => {
      fileReader.onload = () => {
        resolve(fileReader.result);
      };

      fileReader.readAsArrayBuffer(blob);
    });
  },

  delete(id) {
    if (!_cache) return;

    _cache.delete(id);
  },

  isAvailable() {
    return Boolean(_cache);
  }
}
